import { CartAddEvent, CartErrorEvent } from '@theme/events';

class QuickAddList extends HTMLElement {}

/** @param {Event} event */
function handleQuickAddListInputEvent(event) {
  const target = event.target;
  const label = target instanceof Element ? target.closest('.quick-add__button-label') : null;
  const list = label?.closest('quick-add-list');
  const input = target instanceof HTMLInputElement ? target : label?.querySelector('input');

  if (!(list instanceof HTMLElement)) return;
  if (list.getAttribute('aria-busy') === 'true') {
    event.preventDefault();
    return;
  }
  if (!(input instanceof HTMLInputElement) || !input.matches('.quick-add__button-label input')) return;
  if (input.dataset.optionAvailable === 'false') return;

  addVariant(list, input);
}

/**
 * @param {HTMLElement} list
 * @param {HTMLInputElement} input
 */
async function addVariant(list, input) {
  const variantId = input.dataset.variantId;

  if (!variantId) return;

  const sourceId = list.id || variantId;
  const productCard = list.closest('product-card');
  const productId =
    list.dataset.productId || (productCard instanceof HTMLElement ? productCard.dataset.productId : undefined);
  const sectionIds = getCartSectionIds();
  const cartAddUrl = input.form?.action || Theme.routes.cart_add_url;
  const payload = {
    id: Number(variantId),
    quantity: 1,
    ...(sectionIds.length ? { sections: sectionIds.join(',') } : {}),
  };

  list.setAttribute('aria-busy', 'true');
  input.disabled = true;

  try {
    const response = await fetch(cartAddUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(payload),
    });
    const data = await response.json();

    if (!response.ok || data.status) {
      list.dispatchEvent(new CartErrorEvent(sourceId, data.message, data.description, data.errors));
      list.dispatchEvent(
        new CartAddEvent({}, sourceId, {
          didError: true,
          source: 'quick-add-list',
          itemCount: 1,
          productId,
          variantId,
        })
      );
      return;
    }

    const cart = await fetchCart();

    list.dispatchEvent(
      new CartAddEvent(cart ?? data, sourceId, {
        source: 'quick-add-list',
        itemCount: 1,
        productId,
        variantId,
        sections: data.sections,
      })
    );

    closeQuickAddList(list);
  } catch (error) {
    console.error(error);
  } finally {
    input.disabled = false;
    list.removeAttribute('aria-busy');
  }
}

function getCartSectionIds() {
  return Array.from(document.querySelectorAll('cart-items-component'))
    .map((item) => (item instanceof HTMLElement ? item.dataset.sectionId : ''))
    .filter(Boolean);
}

/** @param {HTMLElement} list */
function closeQuickAddList(list) {
  const productCard = list.closest('product-card');
  const quickAddButton = productCard?.querySelector('quick-add-button[aria-expanded="true"]');
  const toggle = quickAddButton?.querySelector('.quick-add-button__toggle');

  quickAddButton?.setAttribute('aria-expanded', 'false');
  toggle?.setAttribute('aria-expanded', 'false');
}

async function fetchCart() {
  try {
    const response = await fetch(`${Theme.routes.cart_url}.js`);
    if (!response.ok) return null;

    return await response.json();
  } catch (error) {
    console.error(error);
    return null;
  }
}

document.addEventListener('click', handleQuickAddListInputEvent);
document.addEventListener('change', handleQuickAddListInputEvent);

if (!customElements.get('quick-add-list')) {
  customElements.define('quick-add-list', QuickAddList);
}
